import { ConfigService } from "../../config/config.service";
import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  AfterViewInit,
  ViewChildren,
} from "@angular/core";
import { AuthService } from "src/app/core/service/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { RightSidebarService } from "src/app/core/service/rightsidebar.service";
import { Role } from "src/app/core/models/role";
import { TranslateService } from "@ngx-translate/core";
import { AllMastersService } from "../../services/masters/all-masters.service";
import { UserManagementService } from "../../services/user-management/user-management.service";
import { ChangePasswordComponent } from "src/app/admin/change-password/change-password.component";
import { MatDialog } from "@angular/material/dialog";
import { NotificationService } from "src/app/services/notification/notification.service";
import { CommonService } from "src/app/core/service/common.service";
//import { AuthService } from "../../core/service/auth.service";
import {
  NgbModal,
  ModalDismissReasons,
  NgbDropdown,
} from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { environment } from "src/environments/environment";

// import { MatDialog } from '@angular/material/dialog';
// import { ChangePasswordComponent } from 'src/app/admin/change-password/change-password.component';
//
const document: any = window.document;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @ViewChildren(NgbDropdown) dropdowns;
  public config: any = {};
  userImg: string;
  homePage: string;
  isNavbarCollapsed = true;
  role_name: any;
  taluka_name: any;
  profile_name: string = "";
  birthdate: string = "";
  current_academic_year: string = "";
  isBirthdayToday: boolean = false;
  id: any;
  user: any;
  user_name: any;
  user_id: any;
  note_id: any;
  notification: any[];
  changePasswordForm: FormGroup;
  profileImageName: string = "";
  profileImageUrl: string = "";
  otherDocumentsName: string = "";
  otherDocumentsUrl: string = "";
  studentDetails: any = [];
  first_name: any;
  last_name: any;
  notification_sent_date: any;
  notification_header: any;
  copylistOfData: any = [];
 
  listOfData: any = [];
  notificationimageUrl: any = [];
  link: any;
  noteid: any;
  role_id: any = "";

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private dataService: RightSidebarService,
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public dialog: MatDialog,
    private commonService: CommonService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    private allMastersService: AllMastersService,
    private userManagementService: UserManagementService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.auth.getUser().then((res: any) => {
      // console.log(res);
      // console.log(res);
      this.fetchDetails(res.employee_id);
    });
    this.renderer.addClass(this.document.body, "side-closed");
    this.renderer.addClass(this.document.body, "submenu-closed");
    this.changePasswordForm = this.formBuilder.group({
      current_password: ["", Validators.required],
      new_password: ["", Validators.required],
      confirm_password: ["", Validators.required],
    });
    this.config = this.configService.configData;
    const userRole = localStorage.getItem("userRole");

    const currentUser = localStorage.getItem("currentUser");

    let parsedUser = JSON.parse(currentUser);

    console.log("parsedUser :", parsedUser);

    this.profile_name = parsedUser.profile_name;
    this.role_name = parsedUser.role_name;
    this.taluka_name = parsedUser.taluka_name;
    this.birthdate = parsedUser.birthdate;
    this.current_academic_year = parsedUser.academic_year_title;
    this.role_id = parsedUser.role_id;
    // var today = new Date().setHours(0, 0, 0, 0);
    var birthdate = new Date(this.birthdate).getTime();

    var today = new Date();
    var nowYear = today.getFullYear();
    var nowMonth = today.getMonth();
    var nowDay = today.getDate();

    var birth = new Date(this.birthdate);

    var birthYear = birth.getFullYear();
    var birthMonth = birth.getMonth();
    var birthDay = birth.getDate();

    var compBirth = birthMonth.toString() + birthDay.toString();
    var compToday = nowMonth.toString() + nowDay.toString();

    if (compBirth == compToday) {
      this.isBirthdayToday = true;
    } else {
      this.isBirthdayToday = false;
    }

    // if (userRole === Role.Admin) {
    // 	this.homePage = 'admin/dashboard/main';
    // } else if (userRole === Role.Teacher) {
    // 	this.homePage = 'teacher/dashboard';
    // } else if (userRole === Role.Student) {
    // 	this.homePage = 'student/dashboard';
    // } else {
    // 	this.homePage = 'admin/dashboard/main';
    // }

    if (this.role_id == 1) {
      this.homePage = "/mmportal/employee-dashboard";
    } else if (this.role_id == 2) {
      this.homePage = "/mmportal/employee-dashboard";
    } else if (this.role_id == 5) {
      this.homePage = "/mmportal/employee-dashboard";
    } else if (this.role_id == 4) {
      this.homePage = "/mmportal/employee-dashboard";
    } else if (this.role_id == 3) {
      this.homePage = "/mmportal/employee-dashboard";
    } else if (this.role_id == 6) {
      this.homePage = "/admin/dashboard/librarian-dashboard";
    } else if (this.role_id == 7) {
      this.homePage = "/admin/dashboard/support-staff-dashboard";
    } else if (this.role_id == 9) {
      this.homePage = "/admin/dashboard/parent-dashboard";
    } else if (this.role_id == 8) {
      this.homePage = "/admin/dashboard/student-dashboard";
    } else if (this.role_id == 10) {
      this.homePage = "/admin/dashboard/hr-dashboard";
    } else if (this.role_id == 11) {
      this.homePage = "/admin/dashboard/finance-admin-dashboard";
    } else if (this.role_id == 12) {
      this.homePage = "/admin/dashboard/storekeeper-dashboard";
    } else if (this.role_id == 0) {
      this.homePage = "/admin/deployment/deployment";
    } else {
      this.homePage = "/authentication/signin";
    }

    this.user = JSON.parse(localStorage.getItem("currentUser"));
    console.log(this.user);
    this.user_id = this.user.user_id;
   // this.fetchDetails();
    this.fetchNotificationByUserId(this.user_id);
    //this.fetchDetails();
  }
organization_name:any;
  fetchDetails(userid){
    this.commonService.userdetails(userid).subscribe(
			(data) => {
       
        this.listOfData = data['employeeDetails'];


        // this.listOfData = [... this.listOfData]
        // this.copylistOfData = [... this.listOfData]
        
        this.organization_name=this.listOfData[0].organization_name;
           console.log(this.organization_name);
			
			},
			(error) => {
				this.showNotification('snackbar-danger', 'Something went wrong', 'top', 'center');
			}
		);
  }

  ngAfterViewInit() {
    // set theme on startup
    if (localStorage.getItem("theme")) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(this.document.body, localStorage.getItem("theme"));
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }

    if (localStorage.getItem("menuOption")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("menuOption")
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "menu_" + this.config.layout.sidebar.backgroundColor
      );
    }

    if (localStorage.getItem("choose_logoheader")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("choose_logoheader")
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "logo-" + this.config.layout.logo_bg_color
      );
    }

    if (localStorage.getItem("sidebar_status")) {
      if (localStorage.getItem("sidebar_status") === "close") {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      } else {
        this.renderer.removeClass(this.document.body, "side-closed");
        this.renderer.removeClass(this.document.body, "submenu-closed");
      }
    } else {
      if (this.config.layout.sidebar.collapsed === true) {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      }
    }
  }
  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }
  mobileMenuSidebarOpen(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains("side-closed");
    if (hasClass) {
      this.renderer.removeClass(this.document.body, "side-closed");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    } else {
      this.renderer.addClass(this.document.body, "side-closed");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }
  public toggleRightSidebar(): void {
    this.dataService.changeMsg(
      (this.dataService.currentStatus._isScalar =
        !this.dataService.currentStatus._isScalar)
    );
  }

  logout() {
    this.authService.logout().subscribe((res) => {
      if (!res.success) {
        this.router.navigate(["/authentication/signin"]);
      }
    });
  }

  openChangePasswordModal(content) {
    this.changePasswordForm.controls["current_password"].setValue("");
    this.changePasswordForm.controls["new_password"].setValue("");
    this.changePasswordForm.controls["confirm_password"].setValue("");
    this.changePasswordForm.controls["current_password"].setErrors(null);
    this.changePasswordForm.controls["new_password"].setErrors(null);
    this.changePasswordForm.controls["confirm_password"].setErrors(null);
    this.modalService.open(content, { centered: true, size: "md" });
  }

  changePassword() {
    for (let i in this.changePasswordForm.controls) {
      this.changePasswordForm.controls[i].markAsDirty();
      this.changePasswordForm.controls[i].updateValueAndValidity();
    }
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
      return;
    }

    if (
      this.changePasswordForm.controls["new_password"].value ===
      this.changePasswordForm.controls["confirm_password"].value
    ) {
      this.userManagementService
        .updatePassword(this.changePasswordForm.value)
        .subscribe(
          (data) => {
            if (data["status_code"] === 400) {
              this.showNotification(
                "snackbar-danger",
                data["message"],
                "top",
                "center"
              );
              return false;
            } else {
              this.showNotification(
                "snackbar-success",
                data["message"],
                "top",
                "center"
              );
              this.modalService.dismissAll();
              this.router.navigate(["/authentication/signin"]);
            }
          },
          (error) => {
            this.showNotification(
              "snackbar-danger",
              "Something went wrong.",
              "top",
              "center"
            );
          }
        );
    } else {
      this.showNotification(
        "snackbar-error",
        "Confirm password does not match with entered new password.",
        "top",
        "center"
      );
    }
  }

  fetchNotificationByUserId(user_id) {
    this.notificationService
      .fetchNotificationByUserId(this.user_id)
      .subscribe((data) => {
        this.notification = data["userNotifications"];
        this.notificationimageUrl = [];
        for (let i = 0; i < this.notification.length; i++) {
          if (
            this.notification[i].profile_image != null &&
            this.notification[i].profile_image != ""
          ) {
            this.profileImageUrl =
              environment.documentUrl + this.notification[i].profile_image;
          } else {
            this.profileImageUrl = "";
          }
          this.first_name = this.notification[i].first_name;
          this.last_name = this.notification[i].last_name;
          this.notification_sent_date =
            this.notification[i].notification_sent_date;
          this.notification_header = this.notification[i].notification_header;
          (this.link = this.notification[i].link),
            (this.noteid = this.notification[i].note_id);
          let details = {
            profileImageUrl: this.profileImageUrl,
            first_name: this.first_name,
            last_name: this.last_name,
            notification_sent_date: this.notification_sent_date,
            notification_header: this.notification_header,
            link: this.link,
            id: this.noteid,
          };
          this.notificationimageUrl.push(details);
        }
      });
  }

  readNotification(id) {
    let note_id = {
      note_id: id,
    };
    this.notificationService.readNotification(note_id).subscribe((data) => { });

    this.notificationDetails(note_id.note_id);
  }
  readeAllNotification() {
    this.notificationService
      .readAllNotification(this.user_id)
      .subscribe((data) => { });
    this.fetchNotificationByUserId(this.user_id);
  }

  viewAllNotification() {
    this.router.navigate([
      "/admin/viewallnotification/view-all-notification",
      btoa(this.user_id),
    ]);
  }

  notificationDetails(id) {
    for (let i = 0; i < this.notification.length; i++) {
      if (
        this.notification[i].note_id == id &&
        this.notification[i].link !== null
      ) {
        this.router.navigate([this.notification[i].link]);
        this.fetchNotificationByUserId(this.user_id);
        break;
      } else {
        this.fetchNotificationByUserId(this.user_id);
        break;
      }
    }
  }
  showNotification(colorName, text, placementFrom, placementAlign) {
    this.snackBar.open(text, "", {
      duration: 2000,
      verticalPosition: placementFrom,
      horizontalPosition: placementAlign,
      panelClass: colorName,
    });
  }
  goToProfile() {
    let roleName = localStorage.getItem("userRole");
    if (roleName == "Admin" || roleName == "Teacher" || roleName == "HR") {
      this.router.navigate(["/admin/employees/profile"]);
    } else if (roleName == "Parent") {
      this.router.navigate(["/admin/parents/profile"]);
    }
  }

  openHelpPdf() {
    this.dropdowns.toArray().forEach((el) => {
      el.close();
    });
    // const fileURL = URL.createObjectURL;
    window.open("", "_blank");
  }
}
